import React from 'react';
import cn from 'classnames';
import IndicatorBadge from '../../common/IndicatorBadge/IndicatorBadge';
import styles from './StatusTableFilter.module.scss';

const StatusTableFilter = ({ indicatorBgColor, stageName, stageCount }) => {
  return (
    <div className={styles.root}>
      {indicatorBgColor && (
        <IndicatorBadge
          className={styles.indicator}
          bgColor={indicatorBgColor}
        />
      )}
      <p className={styles.text}>{stageName}</p>
      <p className={cn(styles.text, styles.rightCol)}>{stageCount}</p>
    </div>
  );
};

export default StatusTableFilter;
